import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
import Box from '@material-ui/core/Box'

import { setLoader } from 'utils/loader'
import Page from 'components/Page'
import Input from 'components/shared/Input'
import { Error, ISubscription, ChannelType } from 'types'
import * as user from 'http/user'
import { RouteComponentProps } from 'react-router-dom'
import TextField from '@material-ui/core/TextField';
import { getTankInfo } from 'http/tank'
import { transformTank } from 'utils/common'
import { toTitleCase } from 'utils/common'
import { typography } from '@material-ui/system'

const MapTimeZones = {
  nsw: "Australia/Sydney",
  vic: "Australia/Victoria",
  nz: "Pacific/Auckland",
  unassigned: "Australia/Sydney"
}



const isValidEmail = (email: string) => {
  if (!email) return false
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

const isValidPhoneNumber = (phone: string) => {
  if (!phone) return false
  const reg = /^((0|\+61)(4))(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
  return reg.test(phone)
}

interface IState {
  usertype: string
  error: Error | string
  emailSubscription: ISubscription
  smsSubscription: ISubscription
  shiftDaysAndTime: object[]
  timezone: string
  deviceId: string
  alarmlevel: number
  accountname: string
  product: string
  isDisplayShift2Monday: boolean
  isDisplayShift3Monday: boolean
  isDisplayShift2Tuesday: boolean
  isDisplayShift3Tuesday: boolean

  isDisplayShift2Wednesday: boolean
  isDisplayShift3Wednesday: boolean

  isDisplayShift2Thursday: boolean
  isDisplayShift3Thursday: boolean

  isDisplayShift2Friday: boolean
  isDisplayShift3Friday: boolean

  isDisplayShift2Saturday: boolean
  isDisplayShift3Saturday: boolean

  isDisplayShift2Sunday: boolean
  isDisplayShift3Sunday: boolean

  showAlarmLevel: boolean
  showOfficeHours: boolean


  //********** Sunday ***************//
  time_from_shift1_sunday: string
  time_to_shift1_sunday: string
  time_from_shift2_sunday: string
  time_to_shift2_sunday: string
  time_from_shift3_sunday: string
  time_to_shift3_sunday: string

  //********** Monday ***************//
  time_from_shift1_monday: string
  time_to_shift1_monday: string
  time_from_shift2_monday: string
  time_to_shift2_monday: string
  time_from_shift3_monday: string
  time_to_shift3_monday: string


  //********** Tuesday ***************//
  time_from_shift1_tuesday: string
  time_to_shift1_tuesday: string
  time_from_shift2_tuesday: string
  time_to_shift2_tuesday: string
  time_from_shift3_tuesday: string
  time_to_shift3_tuesday: string

  //********** Wednesday ***************//
  time_from_shift1_wednesday: string
  time_to_shift1_wednesday: string
  time_from_shift2_wednesday: string
  time_to_shift2_wednesday: string
  time_from_shift3_wednesday: string
  time_to_shift3_wednesday: string

  //********** Thursday ***************//
  time_from_shift1_thursday: string
  time_to_shift1_thursday: string
  time_from_shift2_thursday: string
  time_to_shift2_thursday: string
  time_from_shift3_thursday: string
  time_to_shift3_thursday: string

  //********** Firday ***************//
  time_from_shift1_friday: string
  time_to_shift1_friday: string
  time_from_shift2_friday: string
  time_to_shift2_friday: string
  time_from_shift3_friday: string
  time_to_shift3_friday: string

  //********** Saturday ***************//
  time_from_shift1_saturday: string
  time_to_shift1_saturday: string
  time_from_shift2_saturday: string
  time_to_shift2_saturday: string
  time_from_shift3_saturday: string
  time_to_shift3_saturday: string
}
interface MatchParams {
  tankId: string
}
interface IProps extends RouteComponentProps<MatchParams> {
  tankId: string
}

class Settings extends React.Component<IProps, IState> {
  originalEmailSubscription: ISubscription = {
    optOut: 'ALL',
    type: ChannelType.EMAIL,
    address: ''
  }
  originalSmsSubscription: ISubscription = {
    optOut: 'ALL',
    type: ChannelType.SMS,
    address: ''
  }

  deviceId = ''
  timezone = ''
  // @ts-ignore TODO: find out why this triggers typescript compile failure
  alarmlevel = 0
  accountname = ''
  product = ''

  shiftDaysAndTime = [];

  state = {
    error: Error.NONE,
    emailSubscription: this.originalEmailSubscription,
    smsSubscription: this.originalSmsSubscription,
    timezone: this.timezone,
    shiftDaysAndTime: this.shiftDaysAndTime,
    deviceId: this.deviceId,
    alarmlevel: this.alarmlevel,
    accountname: this.accountname,
    product: this.product,
    isDisplayShift2Monday: false,
    isDisplayShift3Monday: false,

    isDisplayShift2Tuesday: false,
    isDisplayShift3Tuesday: false,

    isDisplayShift2Wednesday: false,
    isDisplayShift3Wednesday: false,

    isDisplayShift2Thursday: false,
    isDisplayShift3Thursday: false,

    isDisplayShift2Friday: false,
    isDisplayShift3Friday: false,

    isDisplayShift2Saturday: false,
    isDisplayShift3Saturday: false,

    isDisplayShift2Sunday: false,
    isDisplayShift3Sunday: false,

    showAlarmLevel: true,
    showOfficeHours: true,


    //********** Sunday******************//
    time_from_shift1_sunday: "",
    time_to_shift1_sunday: "",
    time_from_shift2_sunday: "",
    time_to_shift2_sunday: "",
    time_from_shift3_sunday: "",
    time_to_shift3_sunday: "",

    //********** Monday******************//
    time_from_shift1_monday: "",
    time_to_shift1_monday: "",
    time_from_shift2_monday: "",
    time_to_shift2_monday: "",
    time_from_shift3_monday: "",
    time_to_shift3_monday: "",

    //********** Tuesday******************//
    time_from_shift1_tuesday: "",
    time_to_shift1_tuesday: "",
    time_from_shift2_tuesday: "",
    time_to_shift2_tuesday: "",
    time_from_shift3_tuesday: "",
    time_to_shift3_tuesday: "",

    //********** Wednesday******************//
    time_from_shift1_wednesday: "",
    time_to_shift1_wednesday: "",
    time_from_shift2_wednesday: "",
    time_to_shift2_wednesday: "",
    time_from_shift3_wednesday: "",
    time_to_shift3_wednesday: "",

    //********** Thursday******************//
    time_from_shift1_thursday: "",
    time_to_shift1_thursday: "",
    time_from_shift2_thursday: "",
    time_to_shift2_thursday: "",
    time_from_shift3_thursday: "",
    time_to_shift3_thursday: "",


    //********** Friday******************//
    time_from_shift1_friday: "",
    time_to_shift1_friday: "",
    time_from_shift2_friday: "",
    time_to_shift2_friday: "",
    time_from_shift3_friday: "",
    time_to_shift3_friday: "",

    //********** Saturday******************//
    time_from_shift1_saturday: "",
    time_to_shift1_saturday: "",
    time_from_shift2_saturday: "",
    time_to_shift2_saturday: "",
    time_from_shift3_saturday: "",
    time_to_shift3_saturday: "",
    usertype: ""
  }

  async componentDidMount() {
    let error = Error.NONE
    setLoader(true)
    try {
      const tankId = this.props.match.params.tankId
      this.deviceId = tankId

      const data = await getTankInfo(tankId)
      const tank = transformTank(data.data[tankId])
      if (tank !== undefined) {
        this.state.alarmlevel = tank.alarmlevel
        this.timezone = MapTimeZones[tank.zone]
        if (tank.product !== undefined) {
          this.product = toTitleCase(tank.product)
        }
        else {
          this.product = 'NA'
        }

        if (tank.sh !== undefined) {
          this.accountname = tank.name
        }
        else {
          this.accountname = 'NA'
        }
      }

      const subscription = await user.getSubscription()
      if (subscription.usertype != undefined) {
        this.state.usertype = subscription.usertype
      }
      if (tank.time !== undefined && tank.time.workinghours !== undefined && JSON.parse(tank.time.workinghours) !== "") {
        this.shiftDaysAndTime = JSON.parse(tank.time.workinghours);
      }
      //Is Notfication active or not
      //this.state.showAlarmLevel=subscription.isalarmnotification;//old
      //this.state.showOfficeHours=subscription.isleveldropnotification; 
      if (tank.isalarmnotification != undefined) {
        this.state.showAlarmLevel = tank.isalarmnotification;
      }
      else {
        this.state.showAlarmLevel = false;
      }
      if (tank.isleveldropnotification != undefined) {
        this.state.showOfficeHours = tank.isleveldropnotification;
      }
      else {
        this.state.showOfficeHours = false;
      }
      this.originalEmailSubscription = subscription.emailSubscription
      this.originalSmsSubscription = subscription.smsSubscription
    } catch (err) {
      if (err.message === 'UserAppForbidden') {
        err.message = 'Only Customer account can set shift times';
      }
      error = err.message
    }

    this.setState((state: IState) => ({
      ...state,
      error,
      emailSubscription: this.originalEmailSubscription,
      smsSubscription: this.originalSmsSubscription,
      timezone: this.timezone,
      deviceId: this.deviceId,
      shiftDaysAndTime: this.shiftDaysAndTime,


      //************* Sunday *************/
      time_from_shift1_sunday: "",
      time_to_shift1_sunday: "",

      time_from_shift2_sunday: "",
      time_to_shift2_sunday: "",

      time_from_shift3_sunday: "",
      time_to_shift3_sunday: "",


      //************* Monday *************/
      time_from_shift1_monday: "",
      time_to_shift1_monday: "",

      time_from_shift2_monday: "",
      time_to_shift2_monday: "",

      time_from_shift3_monday: "",
      time_to_shift3_monday: "",

      //************* Tuesday *************/
      time_from_shift1_tuesday: "",
      time_to_shift1_tuesday: "",

      time_from_shift2_tuesday: "",
      time_to_shift2_tuesday: "",

      time_from_shift3_tuesday: "",
      time_to_shift3_tuesday: "",

      //************* Wednesday *************/
      time_from_shift1_wednesday: "",
      time_to_shift1_wednesday: "",

      time_from_shift2_wednesday: "",
      time_to_shift2_wednesday: "",

      time_from_shift3_wednesday: "",
      time_to_shift3_wednesday: "",


      //************* Thursday *************/
      time_from_shift1_thursday: "",
      time_to_shift1_thursday: "",

      time_from_shift2_thursday: "",
      time_to_shift2_thursday: "",

      time_from_shift3_thursday: "",
      time_to_shift3_thursday: "",

      //************* Friday *************/
      time_from_shift1_friday: "",
      time_to_shift1_friday: "",

      time_from_shift2_friday: "",
      time_to_shift2_friday: "",

      time_from_shift3_friday: "",
      time_to_shift3_friday: "",

      //************* Saturday *************/
      time_from_shift1_saturday: "",
      time_to_shift1_saturday: "",

      time_from_shift2_saturday: "",
      time_to_shift2_saturday: "",

      time_from_shift3_saturday: "",
      time_to_shift3_saturday: ""
    }))
    if (this.shiftDaysAndTime.length === 0) {
      this.bindDefaultShiftsAndDays();
    }
    else {
      this.bindSavedShiftsAndDays();
    }
    setLoader(false)
  }

  bindDefaultShiftsAndDays = () => {
    var Sunday = [];
    var Monday = [];
    var Tuesday = [];
    var Wednesday = [];
    var Thursday = [];
    var Friday = [];
    var Saturday = [];

    Sunday.push({
      "from": this.state.time_from_shift1_sunday,
      "to": this.state.time_to_shift1_sunday
    });

    Monday.push({
      "from": this.state.time_from_shift1_monday,
      "to": this.state.time_to_shift1_monday
    });

    Tuesday.push({
      "from": this.state.time_from_shift1_tuesday,
      "to": this.state.time_to_shift1_tuesday
    });

    Wednesday.push({
      "from": this.state.time_from_shift1_wednesday,
      "to": this.state.time_to_shift1_wednesday
    });

    Thursday.push({
      "from": this.state.time_from_shift1_thursday,
      "to": this.state.time_to_shift1_thursday
    });

    Friday.push({
      "from": this.state.time_from_shift1_friday,
      "to": this.state.time_to_shift1_friday
    });

    Saturday.push({
      "from": this.state.time_from_shift1_saturday,
      "to": this.state.time_to_shift1_saturday
    });


    var day0 = "Sunday";
    var day1 = "Monday";
    var day2 = "Tuesday";
    var day3 = "Wednesday";
    var day4 = "Thursday";
    var day5 = "Friday";
    var day6 = "Saturday";

    var data0 = {}, data1 = {}, data2 = {}, data3 = {}, data4 = {}, data5 = {}, data6 = {}

    data0[day0] = Sunday;
    data1[day1] = Monday;
    data2[day2] = Tuesday;
    data3[day3] = Wednesday;
    data4[day4] = Thursday;
    data5[day5] = Friday;
    data6[day6] = Saturday;

    this.shiftDaysAndTime.push(data0);
    this.shiftDaysAndTime.push(data1);
    this.shiftDaysAndTime.push(data2);
    this.shiftDaysAndTime.push(data3);
    this.shiftDaysAndTime.push(data4);
    this.shiftDaysAndTime.push(data5);
    this.shiftDaysAndTime.push(data6);




    console.log('page load array' + JSON.stringify(this.shiftDaysAndTime));

  }

  // Get saved working hours values from db
  bindSavedShiftsAndDays = () => {
    this.shiftDaysAndTime.forEach(day => {



      //************* Sunday**********************/
      if (day.Sunday !== undefined) {
        if (day.Sunday[0] !== undefined) {
          this.setState({
            time_from_shift1_sunday: day.Sunday[0]["from"],
            time_to_shift1_sunday: day.Sunday[0]["to"]
          })
        }
        if (day.Sunday[1] !== undefined) {
          this.setState({
            isDisplayShift2Sunday: true,
            time_from_shift2_sunday: day.Sunday[1]["from"],
            time_to_shift2_sunday: day.Sunday[1]["to"]
          })
        }
        if (day.Sunday[2] !== undefined) {
          this.setState({
            isDisplayShift3Sunday: true,
            time_from_shift3_sunday: day.Sunday[2]["from"],
            time_to_shift3_sunday: day.Sunday[2]["to"]
          })
        }
      }












      //************* Monday**********************/
      if (day.Monday !== undefined) {
        if (day.Monday[0] !== undefined) {
          this.setState({
            time_from_shift1_monday: day.Monday[0]["from"],
            time_to_shift1_monday: day.Monday[0]["to"]
          })
        }
        if (day.Monday[1] !== undefined) {
          this.setState({
            isDisplayShift2Monday: true,
            time_from_shift2_monday: day.Monday[1]["from"],
            time_to_shift2_monday: day.Monday[1]["to"]
          })
        }
        if (day.Monday[2] !== undefined) {
          this.setState({
            isDisplayShift3Monday: true,
            time_from_shift3_monday: day.Monday[2]["from"],
            time_to_shift3_monday: day.Monday[2]["to"]
          })
        }
      }


      //************* Tuesday **********************/
      if (day.Tuesday !== undefined) {
        if (day.Tuesday[0] !== undefined) {
          this.setState({
            time_from_shift1_tuesday: day.Tuesday[0]["from"],
            time_to_shift1_tuesday: day.Tuesday[0]["to"]
          })
        }
        if (day.Tuesday[1] !== undefined) {
          this.setState({
            isDisplayShift2Tuesday: true,
            time_from_shift2_tuesday: day.Tuesday[1]["from"],
            time_to_shift2_tuesday: day.Tuesday[1]["to"]
          })
        }
        if (day.Tuesday[2] !== undefined) {
          this.setState({
            isDisplayShift3Tuesday: true,
            time_from_shift3_tuesday: day.Tuesday[2]["from"],
            time_to_shift3_tuesday: day.Tuesday[2]["to"]
          })
        }
      }


      //************* Wednesday **********************/
      if (day.Wednesday !== undefined) {
        if (day.Wednesday[0] !== undefined) {
          this.setState({
            time_from_shift1_wednesday: day.Wednesday[0]["from"],
            time_to_shift1_wednesday: day.Wednesday[0]["to"]
          })
        }
        if (day.Wednesday[1] !== undefined) {
          this.setState({
            isDisplayShift2Wednesday: true,
            time_from_shift2_wednesday: day.Wednesday[1]["from"],
            time_to_shift2_wednesday: day.Wednesday[1]["to"]
          })
        }
        if (day.Wednesday[2] !== undefined) {
          this.setState({
            isDisplayShift3Wednesday: true,
            time_from_shift3_wednesday: day.Wednesday[2]["from"],
            time_to_shift3_wednesday: day.Wednesday[2]["to"]
          })
        }
      }

      //************* Thursday **********************/
      if (day.Thursday !== undefined) {
        if (day.Thursday[0] !== undefined) {
          this.setState({
            time_from_shift1_thursday: day.Thursday[0]["from"],
            time_to_shift1_thursday: day.Thursday[0]["to"]
          })
        }
        if (day.Thursday[1] !== undefined) {
          this.setState({
            isDisplayShift2Thursday: true,
            time_from_shift2_thursday: day.Thursday[1]["from"],
            time_to_shift2_thursday: day.Thursday[1]["to"]
          })
        }
        if (day.Thursday[2] !== undefined) {
          this.setState({
            isDisplayShift3Thursday: true,
            time_from_shift3_thursday: day.Thursday[2]["from"],
            time_to_shift3_thursday: day.Thursday[2]["to"]
          })
        }
      }


      //************* Friday **********************/
      if (day.Friday !== undefined) {
        if (day.Friday[0] !== undefined) {
          this.setState({
            time_from_shift1_friday: day.Friday[0]["from"],
            time_to_shift1_friday: day.Friday[0]["to"]
          })
        }
        if (day.Friday[1] !== undefined) {
          this.setState({
            isDisplayShift2Friday: true,
            time_from_shift2_friday: day.Friday[1]["from"],
            time_to_shift2_friday: day.Friday[1]["to"]
          })
        }
        if (day.Friday[2] !== undefined) {
          this.setState({
            isDisplayShift3Friday: true,
            time_from_shift3_friday: day.Friday[2]["from"],
            time_to_shift3_friday: day.Friday[2]["to"]
          })
        }
      }



      //************* Saturday **********************/
      if (day.Saturday !== undefined) {
        if (day.Saturday[0] !== undefined) {
          this.setState({
            time_from_shift1_saturday: day.Saturday[0]["from"],
            time_to_shift1_saturday: day.Saturday[0]["to"]
          })
        }
        if (day.Saturday[1] !== undefined) {
          this.setState({
            isDisplayShift2Saturday: true,
            time_from_shift2_saturday: day.Saturday[1]["from"],
            time_to_shift2_saturday: day.Saturday[1]["to"]
          })
        }
        if (day.Saturday[2] !== undefined) {
          this.setState({
            isDisplayShift3Saturday: true,
            time_from_shift3_saturday: day.Saturday[2]["from"],
            time_to_shift3_saturday: day.Saturday[2]["to"]
          })
        }
      }


    });
  }


  toggleSubscription = (type: string) => () => {
    const subscription = this.state[`${type}Subscription`]
    this.setState(state => ({
      ...state,
      error: Error.NONE,
      [`${type}Subscription`]: {
        ...subscription,
        optOut: subscription.optOut === 'ALL' ? 'NONE' : 'ALL'
      }
    }))
  }


  handleInputChange = (type: string) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    const subscription = this.state[`${type}Subscription`]

    this.setState({
      ...this.state,
      [`${type}Subscription`]: {
        ...subscription,
        address: evt.currentTarget.value,
      }
    })
  }
  handleTextChange = (e) => {
    const alarmlevel = parseInt(e.target.value);
    this.setState({
      ...this.state,
      alarmlevel: alarmlevel
    })
  }

  handleDayTimeChange = (event, id) => {

    console.log('track issue' + JSON.stringify(this.shiftDaysAndTime));

    var from_shift1_sunday, to_shift1_sunday, from_shift2_sunday, to_shift2_sunday, from_shift3_sunday, to_shift3_sunday;
    var from_shift1_monday, to_shift1_monday, from_shift2_monday, to_shift2_monday, from_shift3_monday, to_shift3_monday;
    var from_shift1_tuesday, to_shift1_tuesday, from_shift2_tuesday, to_shift2_tuesday, from_shift3_tuesday, to_shift3_tuesday;
    var from_shift1_wednesday, to_shift1_wednesday, from_shift2_wednesday, to_shift2_wednesday, from_shift3_wednesday, to_shift3_wednesday;
    var from_shift1_thursday, to_shift1_thursday, from_shift2_thursday, to_shift2_thursday, from_shift3_thursday, to_shift3_thursday;
    var from_shift1_friday, to_shift1_friday, from_shift2_friday, to_shift2_friday, from_shift3_friday, to_shift3_friday;
    var from_shift1_saturday, to_shift1_saturday, from_shift2_saturday, to_shift2_saturday, from_shift3_saturday, to_shift3_saturday;

    switch (id) {


      //************ Sunday ***************/
      case 'time_from_shift1_sunday':
        from_shift1_sunday = event.target.value;
        this.shiftDaysAndTime[0].Sunday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_sunday':
        to_shift1_sunday = event.target.value;
        this.shiftDaysAndTime[0].Sunday[0]["to"] = event.target.value;
        break;

      case 'time_from_shift2_sunday':
        from_shift2_sunday = event.target.value;
        this.shiftDaysAndTime[0].Sunday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_sunday':
        to_shift2_sunday = event.target.value;
        this.shiftDaysAndTime[0].Sunday[1]["to"] = event.target.value;
        break;

      case 'time_from_shift3_sunday':
        from_shift3_sunday = event.target.value;
        this.shiftDaysAndTime[0].Sunday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_sunday':
        to_shift3_sunday = event.target.value;
        this.shiftDaysAndTime[0].Sunday[2]["to"] = event.target.value;
        break;


      //************ Monday ***************/
      case 'time_from_shift1_monday':
        from_shift1_monday = event.target.value;
        this.shiftDaysAndTime[1].Monday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_monday':
        to_shift1_monday = event.target.value;
        this.shiftDaysAndTime[1].Monday[0]["to"] = event.target.value;
        break;

      case 'time_from_shift2_monday':
        from_shift2_monday = event.target.value;
        this.shiftDaysAndTime[1].Monday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_monday':
        to_shift2_monday = event.target.value;
        this.shiftDaysAndTime[1].Monday[1]["to"] = event.target.value;
        break;

      case 'time_from_shift3_monday':
        from_shift3_monday = event.target.value;
        this.shiftDaysAndTime[1].Monday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_monday':
        to_shift3_monday = event.target.value;
        this.shiftDaysAndTime[1].Monday[2]["to"] = event.target.value;
        break;

      //************ Tuesday ***************/
      case 'time_from_shift1_tuesday':
        from_shift1_tuesday = event.target.value;
        this.shiftDaysAndTime[2].Tuesday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_tuesday':
        to_shift1_tuesday = event.target.value;
        this.shiftDaysAndTime[2].Tuesday[0]["to"] = event.target.value;
        break;
      case 'time_from_shift2_tuesday':
        from_shift2_tuesday = event.target.value;
        this.shiftDaysAndTime[2].Tuesday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_tuesday':
        to_shift2_tuesday = event.target.value;
        this.shiftDaysAndTime[2].Tuesday[1]["to"] = event.target.value;
        break;
      case 'time_from_shift3_tuesday':
        from_shift3_tuesday = event.target.value;
        this.shiftDaysAndTime[2].Tuesday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_tuesday':
        to_shift3_tuesday = event.target.value;
        this.shiftDaysAndTime[2].Tuesday[2]["to"] = event.target.value;
        break;

      //************ Wednesday ***************/
      case 'time_from_shift1_wednesday':
        from_shift1_wednesday = event.target.value;
        this.shiftDaysAndTime[3].Wednesday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_wednesday':
        to_shift1_wednesday = event.target.value;
        this.shiftDaysAndTime[3].Wednesday[0]["to"] = event.target.value;
        break;
      case 'time_from_shift2_wednesday':
        from_shift2_wednesday = event.target.value;
        this.shiftDaysAndTime[3].Wednesday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_wednesday':
        to_shift2_wednesday = event.target.value;
        this.shiftDaysAndTime[3].Wednesday[1]["to"] = event.target.value;
        break;
      case 'time_from_shift3_wednesday':
        from_shift3_wednesday = event.target.value;
        this.shiftDaysAndTime[3].Wednesday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_wednesday':
        to_shift3_wednesday = event.target.value;
        this.shiftDaysAndTime[3].Wednesday[2]["to"] = event.target.value;
        break;

      //************ Thursday ***************/
      case 'time_from_shift1_thursday':
        from_shift1_thursday = event.target.value;
        this.shiftDaysAndTime[4].Thursday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_thursday':
        to_shift1_thursday = event.target.value;
        this.shiftDaysAndTime[4].Thursday[0]["to"] = event.target.value;
        break;
      case 'time_from_shift2_thursday':
        from_shift2_thursday = event.target.value;
        this.shiftDaysAndTime[4].Thursday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_thursday':
        to_shift2_thursday = event.target.value;
        this.shiftDaysAndTime[4].Thursday[1]["to"] = event.target.value;
        break;
      case 'time_from_shift3_thursday':
        from_shift3_thursday = event.target.value;
        this.shiftDaysAndTime[4].Thursday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_thursday':
        to_shift3_thursday = event.target.value;
        this.shiftDaysAndTime[4].Thursday[2]["to"] = event.target.value;
        break;

      //************ Friday ***************/
      case 'time_from_shift1_friday':
        from_shift1_friday = event.target.value;
        this.shiftDaysAndTime[5].Friday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_friday':
        to_shift1_friday = event.target.value;
        this.shiftDaysAndTime[5].Friday[0]["to"] = event.target.value;
        break;
      case 'time_from_shift2_friday':
        from_shift2_friday = event.target.value;
        this.shiftDaysAndTime[5].Friday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_friday':
        to_shift2_friday = event.target.value;
        this.shiftDaysAndTime[5].Friday[1]["to"] = event.target.value;
        break;
      case 'time_from_shift3_friday':
        from_shift3_friday = event.target.value;
        this.shiftDaysAndTime[5].Friday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_friday':
        to_shift3_friday = event.target.value;
        this.shiftDaysAndTime[5].Friday[2]["to"] = event.target.value;
        break;


      //************ Saturday ***************/
      case 'time_from_shift1_saturday':
        from_shift1_saturday = event.target.value;
        this.shiftDaysAndTime[6].Saturday[0]["from"] = event.target.value;
        break;
      case 'time_to_shift1_saturday':
        to_shift1_saturday = event.target.value;
        this.shiftDaysAndTime[6].Saturday[0]["to"] = event.target.value;
        break;
      case 'time_from_shift2_saturday':
        from_shift2_saturday = event.target.value;
        this.shiftDaysAndTime[6].Saturday[1]["from"] = event.target.value;
        break;
      case 'time_to_shift2_saturday':
        to_shift2_saturday = event.target.value;
        this.shiftDaysAndTime[6].Saturday[1]["to"] = event.target.value;
        break;
      case 'time_from_shift3_saturday':
        from_shift3_saturday = event.target.value;
        this.shiftDaysAndTime[6].Saturday[2]["from"] = event.target.value;
        break;
      case 'time_to_shift3_saturday':
        to_shift3_saturday = event.target.value;
        this.shiftDaysAndTime[6].Saturday[2]["to"] = event.target.value;
        break;


      default:
        return 'foo';
    }

    this.setState({


      //*********** Sunday ********************/
      time_from_shift1_sunday: from_shift1_sunday,
      time_to_shift1_sunday: to_shift1_sunday,

      time_from_shift2_sunday: from_shift2_sunday,
      time_to_shift2_sunday: to_shift2_sunday,

      time_from_shift3_sunday: from_shift3_sunday,
      time_to_shift3_sunday: to_shift3_sunday,


      //*********** Monday ********************/
      time_from_shift1_monday: from_shift1_monday,
      time_to_shift1_monday: to_shift1_monday,

      time_from_shift2_monday: from_shift2_monday,
      time_to_shift2_monday: to_shift2_monday,

      time_from_shift3_monday: from_shift3_monday,
      time_to_shift3_monday: to_shift3_monday,



      //*********** Tuesday ********************/
      time_from_shift1_tuesday: from_shift1_tuesday,
      time_to_shift1_tuesday: to_shift1_tuesday,

      time_from_shift2_tuesday: from_shift2_tuesday,
      time_to_shift2_tuesday: to_shift2_tuesday,

      time_from_shift3_tuesday: from_shift3_tuesday,
      time_to_shift3_tuesday: to_shift3_tuesday,


      //*********** Wedneday ********************/
      time_from_shift1_wednesday: from_shift1_wednesday,
      time_to_shift1_wednesday: to_shift1_wednesday,

      time_from_shift2_wednesday: from_shift2_wednesday,
      time_to_shift2_wednesday: to_shift2_wednesday,

      time_from_shift3_wednesday: from_shift3_wednesday,
      time_to_shift3_wednesday: to_shift3_wednesday,

      //*********** Thursday ********************/
      time_from_shift1_thursday: from_shift1_thursday,
      time_to_shift1_thursday: to_shift1_thursday,

      time_from_shift2_thursday: from_shift2_thursday,
      time_to_shift2_thursday: to_shift2_thursday,

      time_from_shift3_thursday: from_shift3_thursday,
      time_to_shift3_thursday: to_shift3_thursday,

      //*********** Friday ********************/
      time_from_shift1_friday: from_shift1_friday,
      time_to_shift1_friday: to_shift1_friday,

      time_from_shift2_friday: from_shift2_friday,
      time_to_shift2_friday: to_shift2_friday,

      time_from_shift3_friday: from_shift3_friday,
      time_to_shift3_friday: to_shift3_friday,


      //*********** Saturday ********************/
      time_from_shift1_saturday: from_shift1_saturday,
      time_to_shift1_saturday: to_shift1_saturday,

      time_from_shift2_saturday: from_shift2_saturday,
      time_to_shift2_saturday: to_shift2_saturday,

      time_from_shift3_saturday: from_shift3_saturday,
      time_to_shift3_saturday: to_shift3_saturday


    })
  };

  backtohome = (deviceId) => {
    document.location.href = "/tank/" + deviceId;
  }

  //Add Shift
  addShift = (day) => {



    //******************* SUNDAY ************************
    if (day === 'Sunday') {
      if (this.state.isDisplayShift2Sunday === false) {
        this.setState({ isDisplayShift2Sunday: true })
        this.shiftDaysAndTime[0].Sunday.splice(1, 0, {
          "from": this.state.time_from_shift2_sunday,
          "to": this.state.time_to_shift2_sunday
        });
      }
      else if (this.state.isDisplayShift2Sunday === true) {
        this.setState({ isDisplayShift3Sunday: true })
        this.shiftDaysAndTime[0].Sunday.splice(2, 0, {
          "from": this.state.time_from_shift3_sunday,
          "to": this.state.time_to_shift3_sunday
        });
      }
    }

    ///*********** Monday **************/
    if (day === 'Monday') {
      if (this.state.isDisplayShift2Monday === false) {
        this.setState({ isDisplayShift2Monday: true })
        this.shiftDaysAndTime[1].Monday.splice(1, 0, {
          "from": this.state.time_from_shift2_monday,
          "to": this.state.time_to_shift2_monday
        });
      }
      else if (this.state.isDisplayShift2Monday === true) {
        this.setState({ isDisplayShift3Monday: true })
        this.shiftDaysAndTime[1].Monday.splice(2, 0, {
          "from": this.state.time_from_shift3_monday,
          "to": this.state.time_to_shift3_monday
        });
      }
    }
    ///*********** Tuesday **************/
    if (day === 'Tuesday') {
      if (this.state.isDisplayShift2Tuesday === false) {
        this.setState({ isDisplayShift2Tuesday: true })
        this.shiftDaysAndTime[2].Tuesday.splice(1, 0, {
          "from": this.state.time_from_shift2_tuesday,
          "to": this.state.time_to_shift2_tuesday
        });
      }
      else if (this.state.isDisplayShift2Tuesday === true) {
        this.setState({ isDisplayShift3Tuesday: true })
        this.shiftDaysAndTime[2].Tuesday.splice(2, 0, {
          "from": this.state.time_from_shift3_tuesday,
          "to": this.state.time_to_shift3_tuesday
        });
      }
    }

    //******************* WEDNESDAY ************************
    if (day === 'Wednesday') {
      if (this.state.isDisplayShift2Wednesday === false) {
        this.setState({ isDisplayShift2Wednesday: true })
        this.shiftDaysAndTime[3].Wednesday.splice(1, 0, {
          "from": this.state.time_from_shift2_wednesday,
          "to": this.state.time_to_shift2_wednesday
        });
      }
      else if (this.state.isDisplayShift2Wednesday === true) {
        this.setState({ isDisplayShift3Wednesday: true })
        this.shiftDaysAndTime[3].Wednesday.splice(2, 0, {
          "from": this.state.time_from_shift3_wednesday,
          "to": this.state.time_to_shift3_wednesday
        });
      }
    }

    //******************* THURSDAY ************************
    if (day === 'Thursday') {
      if (this.state.isDisplayShift2Thursday === false) {
        this.setState({ isDisplayShift2Thursday: true })
        this.shiftDaysAndTime[4].Thursday.splice(1, 0, {
          "from": this.state.time_from_shift2_thursday,
          "to": this.state.time_to_shift2_thursday
        });
      }
      else if (this.state.isDisplayShift2Thursday === true) {
        this.setState({ isDisplayShift3Thursday: true })
        this.shiftDaysAndTime[4].Thursday.splice(2, 0, {
          "from": this.state.time_from_shift3_thursday,
          "to": this.state.time_to_shift3_thursday
        });
      }
    }


    //******************* FRIDAY ************************
    if (day === 'Friday') {
      if (this.state.isDisplayShift2Friday === false) {
        this.setState({ isDisplayShift2Friday: true })
        this.shiftDaysAndTime[5].Friday.splice(1, 0, {
          "from": this.state.time_from_shift2_friday,
          "to": this.state.time_to_shift2_friday
        });
      }
      else if (this.state.isDisplayShift2Friday === true) {
        this.setState({ isDisplayShift3Friday: true })
        this.shiftDaysAndTime[5].Friday.splice(2, 0, {
          "from": this.state.time_from_shift3_friday,
          "to": this.state.time_to_shift3_friday
        });
      }
    }

    //******************* SATURDAY ************************
    if (day === 'Saturday') {
      if (this.state.isDisplayShift2Saturday === false) {
        this.setState({ isDisplayShift2Saturday: true })
        this.shiftDaysAndTime[6].Saturday.splice(1, 0, {
          "from": this.state.time_from_shift2_saturday,
          "to": this.state.time_to_shift2_saturday
        });
      }
      else if (this.state.isDisplayShift2Saturday === true) {
        this.setState({ isDisplayShift3Saturday: true })
        this.shiftDaysAndTime[6].Saturday.splice(2, 0, {
          "from": this.state.time_from_shift3_saturday,
          "to": this.state.time_to_shift3_saturday
        });
      }
    }

  }

  //Remove Shift
  removeShift = (shiftToRemove) => {

    //******************* MONDAY ************************
    if (shiftToRemove === 'isDisplayShift2Monday') {
      this.setState({ isDisplayShift2Monday: false })
      this.shiftDaysAndTime[1].Monday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Monday') {
      this.setState({ isDisplayShift3Monday: false })
      if (this.shiftDaysAndTime[1].Monday.length > 2) {
        this.shiftDaysAndTime[1].Monday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[1].Monday.splice(1, 1);
      }
    }

    //******************* TUESDAY ************************
    if (shiftToRemove === 'isDisplayShift2Tuesday') {
      this.setState({ isDisplayShift2Tuesday: false })
      this.shiftDaysAndTime[2].Tuesday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Tuesday') {
      this.setState({ isDisplayShift3Tuesday: false })
      if (this.shiftDaysAndTime[2].Tuesday.length > 2) {
        this.shiftDaysAndTime[2].Tuesday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[2].Tuesday.splice(1, 1);
      }
    }
    //******************* WEDNESDAY ************************
    if (shiftToRemove === 'isDisplayShift2Wednesday') {
      this.setState({ isDisplayShift2Wednesday: false })
      this.shiftDaysAndTime[3].Wednesday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Wednesday') {
      this.setState({ isDisplayShift3Wednesday: false })
      if (this.shiftDaysAndTime[3].Wednesday.length > 2) {
        this.shiftDaysAndTime[3].Wednesday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[3].Wednesday.splice(1, 1);
      }
    }

    //******************* THURSDAY ************************
    if (shiftToRemove === 'isDisplayShift2Thursday') {
      this.setState({ isDisplayShift2Thursday: false })
      this.shiftDaysAndTime[4].Thursday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Thursday') {
      this.setState({ isDisplayShift3Thursday: false })
      if (this.shiftDaysAndTime[4].Thursday.length > 2) {
        this.shiftDaysAndTime[4].Thursday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[4].Thursday.splice(1, 1);
      }
    }

    //******************* FRIDAY ************************
    if (shiftToRemove === 'isDisplayShift2Friday') {
      this.setState({ isDisplayShift2Friday: false })
      this.shiftDaysAndTime[5].Friday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Friday') {
      this.setState({ isDisplayShift3Friday: false })
      if (this.shiftDaysAndTime[5].Friday.length > 2) {
        this.shiftDaysAndTime[5].Friday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[5].Friday.splice(1, 1);
      }
    }

    //******************* SATURDAY ************************
    if (shiftToRemove === 'isDisplayShift2Saturday') {
      this.setState({ isDisplayShift2Saturday: false })
      this.shiftDaysAndTime[5].Saturday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Saturday') {
      this.setState({ isDisplayShift3Saturday: false })
      if (this.shiftDaysAndTime[6].Saturday.length > 2) {
        this.shiftDaysAndTime[6].Saturday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[6].Saturday.splice(1, 1);
      }
    }
    //******************* SUNDAY ************************
    if (shiftToRemove === 'isDisplayShift2Sunday') {
      this.setState({ isDisplayShift2Sunday: false })
      this.shiftDaysAndTime[0].Sunday.splice(1, 1);
    }
    if (shiftToRemove === 'isDisplayShift3Sunday') {
      this.setState({ isDisplayShift3Sunday: false })
      if (this.shiftDaysAndTime[0].Sunday.length > 2) {
        this.shiftDaysAndTime[0].Sunday.splice(2, 1);
      }
      else {
        this.shiftDaysAndTime[0].Sunday.splice(1, 1);
      }
    }
  }


  _toggleAlarmLevel = () => {
    this.setState({
      ...this.state,
      showAlarmLevel: !this.state.showAlarmLevel,
    })
  }

  _toggleOfficeHours = () => {
    this.setState({
      ...this.state,
      showOfficeHours: !this.state.showOfficeHours,
    })
  }

  saveSettings = async () => {
    let error = Error.NONE
    const {
      emailSubscription,
      smsSubscription,
      timezone,
      alarmlevel,
      deviceId,
      shiftDaysAndTime,
      showAlarmLevel,
      showOfficeHours
    } = this.state

    if (
      emailSubscription.optOut === 'NONE' &&
      !isValidEmail(emailSubscription.address)
    ) {
      return this.setState({
        ...this.state,
        error: 'Email address is invalid'
      })
    }

    if (
      smsSubscription.optOut === 'NONE' &&
      !isValidPhoneNumber(smsSubscription.address)
    ) {
      return this.setState({
        ...this.state,
        error: 'Phone number is invalid'
      })
    }
    const shiftValidationMsg = 'Shift should be more than an hour';

    // ***************************** Sunday **********************************************************
    if (this.shiftDaysAndTime[0].Sunday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[0].Sunday[0]["to"]) - parseInt(this.shiftDaysAndTime[0].Sunday[0]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Sunday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[0].Sunday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[0].Sunday[1]["to"]) - parseInt(this.shiftDaysAndTime[0].Sunday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Sunday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[0].Sunday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[0].Sunday[2]["to"]) - parseInt(this.shiftDaysAndTime[0].Sunday[2]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Sunday Shift 3: ' + shiftValidationMsg
        })
      }
    }

    // ***************************** Monday **********************************************************
    if (this.shiftDaysAndTime[1].Monday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[1].Monday[0]["to"]) - parseInt(this.shiftDaysAndTime[1].Monday[0]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Monday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[1].Monday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[1].Monday[1]["to"]) - parseInt(this.shiftDaysAndTime[1].Monday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Monday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[1].Monday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[1].Monday[2]["to"]) - parseInt(this.shiftDaysAndTime[1].Monday[2]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Monday Shift 3: ' + shiftValidationMsg
        })
      }
    }







    // ***************************** Tuesday **********************************************************
    if (this.shiftDaysAndTime[2].Tuesday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[2].Tuesday[0]["to"]) - parseInt(this.shiftDaysAndTime[2].Tuesday[0]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Tuesday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[2].Tuesday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[2].Tuesday[1]["to"]) - parseInt(this.shiftDaysAndTime[2].Tuesday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Tuesday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[2].Tuesday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[2].Tuesday[2]["to"]) - parseInt(this.shiftDaysAndTime[2].Tuesday[2]["from"]);

      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Tuesday Shift 3: ' + shiftValidationMsg
        })
      }
    }









    // ***************************** Wednesday **********************************************************
    if (this.shiftDaysAndTime[3].Wednesday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[3].Wednesday[0]["to"]) - parseInt(this.shiftDaysAndTime[3].Wednesday[0]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Wednesday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[3].Wednesday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[3].Wednesday[1]["to"]) - parseInt(this.shiftDaysAndTime[3].Wednesday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Wednesday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[3].Wednesday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[3].Wednesday[2]["to"]) - parseInt(this.shiftDaysAndTime[3].Wednesday[2]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Wednesday Shift 3: ' + shiftValidationMsg
        })
      }
    }





    // ***************************** Thursday **********************************************************
    if (this.shiftDaysAndTime[4].Thursday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[4].Thursday[0]["to"]) - parseInt(this.shiftDaysAndTime[4].Thursday[0]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Thursday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[4].Thursday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[4].Thursday[1]["to"]) - parseInt(this.shiftDaysAndTime[4].Thursday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Thursday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[4].Thursday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[4].Thursday[2]["to"]) - parseInt(this.shiftDaysAndTime[4].Thursday[2]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Thursday Shift 3: ' + shiftValidationMsg
        })
      }
    }







    // ***************************** Friday **********************************************************
    if (this.shiftDaysAndTime[5].Friday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[5].Friday[0]["to"]) - parseInt(this.shiftDaysAndTime[5].Friday[0]["from"]);

      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Friday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[5].Friday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[5].Friday[1]["to"]) - parseInt(this.shiftDaysAndTime[5].Friday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Friday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[5].Friday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[5].Friday[2]["to"]) - parseInt(this.shiftDaysAndTime[5].Friday[2]["from"]);

      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Friday Shift 3: ' + shiftValidationMsg
        })
      }
    }






    // ***************************** Saturday **********************************************************
    if (this.shiftDaysAndTime[6].Saturday[0] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[6].Saturday[0]["to"]) - parseInt(this.shiftDaysAndTime[6].Saturday[0]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Saturday Shift 1: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[6].Saturday[1] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[6].Saturday[1]["to"]) - parseInt(this.shiftDaysAndTime[6].Saturday[1]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Saturday Shift 2: ' + shiftValidationMsg
        })
      }
    }

    if (this.shiftDaysAndTime[6].Saturday[2] != undefined) {
      var diff = parseInt(this.shiftDaysAndTime[6].Saturday[2]["to"]) - parseInt(this.shiftDaysAndTime[6].Saturday[2]["from"]);
      if (diff < 1) {
        return this.setState({
          ...this.state,
          error: 'Saturday Shift 3: ' + shiftValidationMsg
        })
      }
    }

    setLoader(true)
    try {
      console.log('save updates----' + JSON.stringify(this.shiftDaysAndTime));
      const subscription = {
        deviceId,
        alarmlevel,
        time: {
          timezone,
          shiftDaysAndTime
        },
        shiftDaysAndTime,
        showAlarmLevel,
        showOfficeHours,
        targets: [emailSubscription, smsSubscription]
      }
      console.log('save subscription new latest' + JSON.stringify(subscription));
      const data = await user.updateSubscription(subscription)
      if (data.messageStatus === 'error') {
        error = data.messageCode
      } else {
        this.originalEmailSubscription = emailSubscription
        alert("Settings saved successfully");
      }
    } catch (err) {
      console.log(err)
      error = err.message
    }
    this.setState({
      ...this.state,
      error
    })
    setLoader(false)
  }

  render() {
    const {
      usertype,
      error,
      smsSubscription,
      emailSubscription,
      isDisplayShift2Monday,
      isDisplayShift3Monday,
      isDisplayShift2Tuesday,
      isDisplayShift3Tuesday,
      isDisplayShift2Wednesday,
      isDisplayShift3Wednesday,

      isDisplayShift2Thursday,
      isDisplayShift3Thursday,
      isDisplayShift2Friday,
      isDisplayShift3Friday,

      isDisplayShift2Saturday,
      isDisplayShift3Saturday,

      isDisplayShift2Sunday,
      isDisplayShift3Sunday,

      showAlarmLevel,
      showOfficeHours,

      //********** Sunday *************/
      time_from_shift1_sunday,
      time_to_shift1_sunday,
      time_from_shift2_sunday,
      time_to_shift2_sunday,
      time_from_shift3_sunday,
      time_to_shift3_sunday,

      //********** Monday *************/
      time_from_shift1_monday,
      time_to_shift1_monday,
      time_from_shift2_monday,
      time_to_shift2_monday,
      time_from_shift3_monday,
      time_to_shift3_monday,

      //********** Tuesday *************/
      time_from_shift1_tuesday,
      time_to_shift1_tuesday,
      time_from_shift2_tuesday,
      time_to_shift2_tuesday,
      time_from_shift3_tuesday,
      time_to_shift3_tuesday,

      //********** Wednesday *************/
      time_from_shift1_wednesday,
      time_to_shift1_wednesday,
      time_from_shift2_wednesday,
      time_to_shift2_wednesday,
      time_from_shift3_wednesday,
      time_to_shift3_wednesday,

      //********** Thursday *************/
      time_from_shift1_thursday,
      time_to_shift1_thursday,
      time_from_shift2_thursday,
      time_to_shift2_thursday,
      time_from_shift3_thursday,
      time_to_shift3_thursday,

      //********** Friday *************/
      time_from_shift1_friday,
      time_to_shift1_friday,
      time_from_shift2_friday,
      time_to_shift2_friday,
      time_from_shift3_friday,
      time_to_shift3_friday,


      //********** Saturday *************/
      time_from_shift1_saturday,
      time_to_shift1_saturday,
      time_from_shift2_saturday,
      time_to_shift2_saturday,
      time_from_shift3_saturday,
      time_to_shift3_saturday
    } = this.state

    return (
      <Page title="Settings">
        <Typography variant="h2" color="textSecondary">Notification Settings</Typography>
        <Grid item style={{ float: "right" }}>
          <Button style={{ backgroundColor: "#F8F5ED", color: "black" }} onClick={() => this.backtohome(this.deviceId)} > Go Back </Button>
        </Grid>
        <Typography variant="h6" color="textSecondary" style={{ marginTop: '15px', marginBottom: '15px' }}>For account name: <label style={{ fontWeight: "bold" }}>{this.accountname}</label> </Typography>
        <Typography variant="h6" color="textSecondary">Product: <label style={{ fontWeight: "bold" }}>{this.product}</label> </Typography>
        <Typography variant="h4" color="textSecondary" style={{ marginTop: '15px', marginBottom: '15px' }}>In order to receive notifications, please specify your email or/and SMS:</Typography>
        <Box display="flex" justifyContent="left">
          <Box border={1} style={{ backgroundColor: "#F8F5ED", width: '80%', height: 'auto' }} >
            <Grid item container direction="column" style={{ marginLeft: '20px', width: '80%' }}>
              <Grid container item justify="space-between" alignItems="center">
                <Grid item>
                  <Typography variant="h3" color="textSecondary"> <img style={{ width: '25px' }} src="/images/icons/email.svg" alt="" /> By Email</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    onChange={this.toggleSubscription('email')}
                    checked={emailSubscription.optOut === 'NONE'}
                  />
                </Grid>
              </Grid>
              {emailSubscription.optOut === 'NONE' && (
                <Grid item>
                  <Box pl={4}>
                    <Input
                      label="Email"
                      type="text"
                      value={emailSubscription.address}
                      onChange={this.handleInputChange('email')}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
            <Grid item container direction="column" style={{ margin: '20px', width: '80%' }}>
              <Grid container item justify="space-between" alignItems="center">
                <Grid item>
                  <Typography variant="h3" color="textSecondary"> <img style={{ width: '25px' }} src="/images/icons/sms.svg" alt="" /> By SMS</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    onChange={this.toggleSubscription('sms')}
                    checked={smsSubscription.optOut === 'NONE'}
                  />
                </Grid>
              </Grid>
              {smsSubscription.optOut === 'NONE' && (
                <Grid item>
                  <Box pl={4}>
                    <Input
                      label="Phone Number"
                      type="text"
                      value={smsSubscription.address}
                      onChange={this.handleInputChange('sms')}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>

        {/* Alarm Settings */}

        <Typography variant="h4" color="textSecondary" style={{ marginTop: '15px', marginBottom: '15px' }}>What notifications would you like to receive?</Typography>
        <Box display="flex" justifyContent="left">
          <Box border={1} style={{ backgroundColor: "#F8F5ED", width: '80%', height: 'auto' }} >
            <Grid item container direction="column" style={{ marginLeft: '20px', width: '80%' }}>
              <Grid container item justify="space-between" alignItems="center">
                <Grid item>
                  <Typography variant="h3" color="textSecondary"><img style={{ width: '25px' }} src="/images/icons/levelalarm.svg" alt="" /> Level alarm</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    onChange={this._toggleAlarmLevel}
                    checked={showAlarmLevel} />
                </Grid>
              </Grid>
              {showAlarmLevel && (
                <Grid item>
                  <Typography style={{ fontSize: "16px", color: "gray" }} color="textSecondary">You will receive an SMS and/or Email notification any time the tank level drops below the 'Set Alarm level in %'</Typography>
                  <Box pl={4}>
                    <Input
                      label="Set Alarm Level in %"
                      type="text"
                      maxLength={2}
                      value={this.state.alarmlevel || ''}
                      onChange={(value) => this.handleTextChange(value)}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>

        {/* Working hours settings */}

        <Box display="flex" justifyContent="left" style={{ marginTop: "15px" }}>
          <Box border={1} style={{ backgroundColor: "#F8F5ED", width: '80%', height: 'auto' }} >
            <Grid item container direction="column" style={{ marginLeft: '10px', width: '82%' }}>
              <Grid container item alignItems="center">
                <Grid item style={{ width: '43px' }}>
                  <Typography variant="h3" color="textSecondary"><img style={{ width: '45px', height: '45px' }} src="/images/icons/bell.svg" alt="" /></Typography>
                </Grid>
                <Grid item style={{ width: '87%' }}>
                  <Typography variant="h3" color="textSecondary">Outside of working hours usage alarm</Typography>
                </Grid>
                <Grid item style={{ width: '3px' }}>
                  </Grid>
                <Grid item >
                  <Switch
                    onChange={this._toggleOfficeHours}
                    checked={showOfficeHours}
                  />
                </Grid>
              </Grid>
              {showOfficeHours && (
                <div>
                  {/* Monday office hours */}
                  <Grid id="top-row" container>

                    <Grid item>
                      <Typography style={{ fontSize: "16px", color: "gray", marginTop: "10px" }} color="textSecondary">You will receive an SMS and/or Email notification if the tank level drops outside of your defined working hours.</Typography>
                      <Typography style={{ fontSize: "16px", color: "gray", marginTop: "10px" }} color="textSecondary">Please specify the hours that the tank will be in use:</Typography>
                    </Grid>

                    <Grid item xs={4} style={{ marginTop: "10px" }}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Monday</Typography>
                    </Grid>
                  </Grid>

                  {/* Monday Shift -1  */}

                  <Grid id="monday-shift-1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                     </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        type="time"
                        value={time_from_shift1_monday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_monday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        type="time"
                        value={time_to_shift1_monday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_monday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                  </Grid>

                  {/* Monday Shift - 2  */}

                  {isDisplayShift2Monday && (<Grid id="monday-shift-2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        type="time"
                        value={time_from_shift2_monday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_monday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Monday"
                        type="time"
                        value={time_to_shift2_monday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_monday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftMonday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Monday')}>Delete</Button>
                    </Grid>
                  </Grid>)}

                  {/* Monday Shift - 3  */}

                  {isDisplayShift3Monday && (<Grid id="monday-shift-2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Monday"
                        type="time"
                        value={time_from_shift3_monday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_monday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Monday"
                        type="time"
                        value={time_to_shift3_monday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_monday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftMonday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Monday')}>Delete</Button>
                    </Grid>
                  </Grid>)}

                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftMonday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Monday')}>Add Shift +</Button>
                    </Grid>
                  </Grid>

                  {/* Tuesday office hours */}

                  <Grid id="top-row" container>
                    <Grid item xs={4}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Tuesday</Typography>
                    </Grid>
                  </Grid>

                  {/* Tuesday Shift -1  */}

                  <Grid id="TuesdayShift1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        type="time"
                        value={time_from_shift1_tuesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_tuesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift1Tuesday"
                        type="time"
                        value={time_to_shift1_tuesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_tuesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                  </Grid>


                  {/* Tuesday Shift - 2  */}

                  {isDisplayShift2Tuesday && (<Grid id="TuesdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift2Tuesday"
                        type="time"
                        value={time_from_shift2_tuesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_tuesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Tuesday"
                        type="time"
                        value={time_to_shift2_tuesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_tuesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftTuesday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Tuesday')}>Delete</Button>
                    </Grid>
                  </Grid>)}


                  {/* Tuesday Shift - 3  */}

                  {isDisplayShift3Tuesday && (<Grid id="TuesdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Tuesday"
                        type="time"
                        value={time_from_shift3_tuesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_tuesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Tuesday"
                        type="time"
                        value={time_to_shift3_tuesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_tuesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>

                    <Grid item style={{ marginLeft: "15px" }}>

                      <Button id="btnRemoveShiftTuesday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Tuesday')}>Delete</Button>

                    </Grid>
                  </Grid>)}

                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftTuesday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Tuesday')}>Add Shift +</Button>
                    </Grid>
                  </Grid>



                  {/* Wednesday office hours */}

                  <Grid id="top-row" container>
                    <Grid item xs={4}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Wednesday</Typography>

                    </Grid>

                  </Grid>

                  {/* Wednesday Shift -1  */}

                  <Grid id="WednesdayShift1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift1Wednesday"
                        type="time"
                        value={time_from_shift1_wednesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_wednesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 5 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift1Wednesday"
                        type="time"
                        value={time_to_shift1_wednesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_wednesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 5 min
                        }}
                      />
                    </Grid>
                  </Grid>


                  {/* Wednesday Shift - 2  */}

                  {isDisplayShift2Wednesday && (<Grid id="WednesdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift2Wednesday"
                        type="time"
                        value={time_from_shift2_wednesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_wednesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Wednesday"
                        type="time"
                        value={time_to_shift2_wednesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_wednesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>


                    <Grid item style={{ marginLeft: "15px" }}>

                      <Button id="btnRemoveShiftWednesday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Wednesday')}>Delete</Button>

                    </Grid>
                  </Grid>)}


                  {/* Wednesday Shift - 3  */}

                  {isDisplayShift3Wednesday && (<Grid id="WednesdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Wednesday"
                        type="time"
                        value={time_from_shift3_wednesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_wednesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Wednesday"
                        type="time"
                        value={time_to_shift3_wednesday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_wednesday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>

                    <Grid item style={{ marginLeft: "15px" }}>

                      <Button id="btnRemoveShiftWednesday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Wednesday')}>Delete</Button>

                    </Grid>
                  </Grid>)}


                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftWednesday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Wednesday')}>Add Shift +</Button>
                      {/* <Button id="btnRemoveShiftTuesday" style={{ backgroundColor: "gray", color: "black",margin:"10px" }} onClick={() => this.removeShift('Tuesday')}>Remove Shift -</Button> */}
                    </Grid>
                  </Grid>



                  {/* Thursday office hours */}

                  <Grid id="top-row" container>
                    <Grid item xs={4}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Thursday</Typography>

                    </Grid>

                  </Grid>

                  {/* Thursday Shift -1  */}

                  <Grid id="ThursdayShift1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift1Thursday"
                        type="time"
                        value={time_from_shift1_thursday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_thursday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 5 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift1Thursday"
                        type="time"
                        value={time_to_shift1_thursday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_thursday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 5 min
                        }}
                      />
                    </Grid>
                  </Grid>


                  {/* Thursday Shift - 2  */}

                  {isDisplayShift2Thursday && (<Grid id="ThursdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift2Thursday"
                        type="time"
                        value={time_from_shift2_thursday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_thursday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Thursday"
                        type="time"
                        value={time_to_shift2_thursday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_thursday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftThursday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Thursday')}>Delete</Button>
                    </Grid>
                  </Grid>)}


                  {/* Thursday Shift - 3  */}

                  {isDisplayShift3Thursday && (<Grid id="ThursdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Thursday"
                        type="time"
                        value={time_from_shift3_thursday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_thursday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Thursday"
                        type="time"
                        value={time_to_shift3_thursday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_thursday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftThursday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Thursday')}>Delete</Button>
                    </Grid>
                  </Grid>)}
                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftThursday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Thursday')}>Add Shift +</Button>
                    </Grid>
                  </Grid>


                  {/* Friday office hours */}

                  <Grid id="top-row" container>
                    <Grid item xs={4}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Friday</Typography>
                    </Grid>
                  </Grid>

                  {/* Friday Shift -1  */}

                  <Grid id="FridayShift1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift1Friday"
                        type="time"
                        value={time_from_shift1_friday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_friday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift1Friday"
                        type="time"
                        value={time_to_shift1_friday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_friday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 5 min
                        }}
                      />
                    </Grid>
                  </Grid>

                  {/* Friday Shift - 2  */}

                  {isDisplayShift2Friday && (<Grid id="FridayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift2Friday"
                        type="time"
                        value={time_from_shift2_friday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_friday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Friday"
                        type="time"
                        value={time_to_shift2_friday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_friday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftFriday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Friday')}>Delete</Button>
                    </Grid>
                  </Grid>)}


                  {/* Friday Shift - 3  */}

                  {isDisplayShift3Friday && (<Grid id="FridayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Friday"
                        type="time"
                        value={time_from_shift3_friday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_friday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
</Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Friday"
                        type="time"
                        value={time_to_shift3_friday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_friday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>

                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftFriday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Friday')}>Delete</Button>
                    </Grid>
                  </Grid>)}


                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftFriday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Friday')}>Add Shift +</Button>
                    </Grid>
                  </Grid>


                  {/* Saturday office hours */}

                  <Grid id="top-row" container>
                    <Grid item xs={4}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Saturday</Typography>
                    </Grid>
                  </Grid>

                  {/* Saturday Shift -1  */}

                  <Grid id="SaturdayShift1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                  </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift1Saturday"
                        type="time"
                        value={time_from_shift1_saturday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_saturday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift1Saturday"
                        type="time"
                        value={time_to_shift1_saturday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_saturday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                  </Grid>


                  {/* Saturday Shift - 2  */}

                  {isDisplayShift2Saturday && (<Grid id="SaturdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift2Saturday"
                        type="time"
                        value={time_from_shift2_saturday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_saturday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Saturday"
                        type="time"
                        value={time_to_shift2_saturday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_saturday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftSaturday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Saturday')}>Delete</Button>
                    </Grid>
                  </Grid>)}


                  {/* Saturday Shift - 3  */}

                  {isDisplayShift3Saturday && (<Grid id="SaturdayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Saturday"
                        type="time"
                        value={time_from_shift3_saturday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_saturday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Saturday"
                        type="time"
                        value={time_to_shift3_saturday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_saturday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>

                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftSaturday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Saturday')}>Delete</Button>
                    </Grid>
                  </Grid>)}
                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftSaturday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Saturday')}>Add Shift +</Button>
                    </Grid>
                  </Grid>


                  {/* Sunday office hours */}

                  <Grid id="top-row" container>
                    <Grid item xs={4}>
                      <Typography variant="h4" color="textSecondary" style={{ fontWeight: "bold" }}>Sunday</Typography>
                    </Grid>
                  </Grid>

                  {/* Sunday Shift -1  */}

                  <Grid id="SundayShift1" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift1Sunday"
                        type="time"
                        value={time_from_shift1_sunday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift1_sunday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift1Sunday"
                        type="time"
                        value={time_to_shift1_sunday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift1_sunday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 5 min
                        }}
                      />
                    </Grid>
                  </Grid>


                  {/* Sunday Shift - 2  */}

                  {isDisplayShift2Sunday && (<Grid id="SundayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift2Sunday"
                        type="time"
                        value={time_from_shift2_sunday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift2_sunday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift2Sunday"
                        type="time"
                        value={time_to_shift2_sunday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift2_sunday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftSunday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift2Sunday')}>Delete</Button>
                    </Grid>
                  </Grid>)}


                  {/* Sunday Shift - 3  */}

                  {isDisplayShift3Sunday && (<Grid id="SundayShift2" container style={{ marginTop: "10px" }}>
                    <Grid item>
                      From
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="fromShift3Sunday"
                        type="time"
                        value={time_from_shift3_sunday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_from_shift3_sunday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      To
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <TextField
                        id="toShift3Sunday"
                        type="time"
                        value={time_to_shift3_sunday}
                        onChange={(e) => this.handleDayTimeChange(e, 'time_to_shift3_sunday')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 1800, // 30 min
                        }}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "15px" }}>
                      <Button id="btnRemoveShiftSunday" style={{ backgroundColor: "gray", color: "black", width: '30px' }} onClick={() => this.removeShift('isDisplayShift3Sunday')}>Delete</Button>
                    </Grid>
                  </Grid>)}
                  <Grid container>
                    <Grid item>
                      <Button id="btnAddShiftSunday" style={{ backgroundColor: "gray", color: "black", margin: "10px" }} onClick={() => this.addShift('Sunday')}>Add Shift +</Button>
                    </Grid>
                  </Grid>
                </div>
              )}
            </Grid>
          </Box>
        </Box>


        {usertype === "customer" && (<Grid container direction="column" style={{ marginTop: "15px" }}>
          <Grid item xs={12} sm={6} xl={4}>
            <Grid container direction="column" spacing={4}>
              <Grid item>
                <Button fullWidth onClick={this.saveSettings}>
                  <Typography color="primary">
                    Save
                  </Typography>
                </Button>
              </Grid>
              <Grid item>
                {error !== Error.NONE && (
                  <Grid item>
                    <Typography variant="h3" color="error">{error}</Typography>
                  </Grid>
                )}
              </Grid>

            </Grid>

          </Grid>

        </Grid>)}






        {usertype === "admin" && (<Grid container direction="column" style={{ marginTop: "15px" }}>
          <Grid item xs={12} sm={6} xl={4}>
            <Grid container direction="column" spacing={4}>
              <Grid item>
                <Typography variant="h3" color="error">Only Customers can save data in settings.</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>)}


      </Page>
    )
  }
}

export default Settings
